import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { IModuleStrings } from '@platform/core/types';
import { formatDate, formatNumber } from '@platform/core/lib/format';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IValueText } from '../options/IValueText';

/** Форматувальник значень для уточнень списків вибору: рядки модуля цільового типу, дата й число мовою інтерфейсу. */
export function useValueText(strings: IModuleStrings, rtKey: string): IValueText {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  return useMemo(() => ({
    option: (fieldKey, value, fallback) => strings.option(rtKey, fieldKey, value, fallback),
    status: (value, fallback) => strings.status(rtKey, value, fallback),
    date: (iso) => formatDate(iso, lang),
    number: (n) => formatNumber(n, lang),
    yes: t('fieldControls.yes'),
    no: t('fieldControls.no'),
  }), [strings, rtKey, lang, t]);
}
